module.exports = __webpack_public_path__ + "static/media/contact19.01d16acd.png";